// Brutal Strike forgoes any Advantage on its attack roll (2024): this entry in suppressedAdvantageSources drops every
// Advantage source, not just Reckless Attack's.
export const FORGO_ALL_ADVANTAGE = '*';

export const withoutSuppressedAdvantages = (sources = [], suppressed = []) =>
  (suppressed.includes(FORGO_ALL_ADVANTAGE) ? [] : sources.filter((source) => !suppressed.includes(source)));
